// extracted by mini-css-extract-plugin
export default {"link":"UEzkhNqu65IW_NeveEYn","text":"FC53qoeUizjhreue5Ig_"};